import React, { useState } from 'react';
import { Trash2Icon } from 'lucide-react';
import { Button } from '../ui/Button';
import { useRegistry, type ActivityKind } from '../../contexts/RegistryContext';
import { formatWhen } from '../../utils/adminFormat';
const kindLabels: Record<ActivityKind, string> = {
  registration: 'Registration',
  assistant: 'Velnoris AI',
  message: 'Message',
  job: 'Job',
  assignment: 'Assignment',
  system: 'System'
};
export function ActivityPanel() {
  const {
    activity,
    clearActivity
  } = useRegistry();
  const [kind, setKind] = useState<ActivityKind | 'all'>('all');
  const rows = kind === 'all' ? activity : activity.filter(a => a.kind === kind);
  return <div data-id="element-28" data-mp="k1pmaqdrhq1f">
      <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-29" data-mp="k2hj24j3htta">
        <div className="flex flex-wrap items-center gap-2" data-id="element-30" data-mp="k3sjbudc0jfn">
          <label htmlFor="act-kind" className="font-sans text-[0.8125rem] text-charcoal-700" data-id="element-31" data-mp="3irgcxdw9q3od">
            Show
          </label>
          <select id="act-kind" value={kind} onChange={e => setKind(e.target.value as ActivityKind | 'all')} className="border border-navy-100 bg-white px-2.5 py-1.5 font-sans text-[0.8125rem] text-ink" data-id="element-32" data-mp="3nopygigjdv6x">
            <option value="all" data-id="element-33" data-mp="hz06sq7nyioy">Everything</option>
            {(Object.keys(kindLabels) as ActivityKind[]).map(k => <option key={k} value={k} data-id="element-34" data-mp="cz5jsxr0ed96">
                {kindLabels[k]}
              </option>)}
          </select>
        </div>
        <Button size="sm" variant="danger" onClick={clearActivity} disabled={!activity.length} data-id="element-35" data-mp="400jpmzsubuw">
          <Trash2Icon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-36" data-mp="3v6bex2i4oieb" />
          Clear log
        </Button>
      </div>

      {!rows.length ? <p className="mt-6 border border-dashed border-navy-200 bg-white p-10 text-center font-sans text-[0.875rem] text-charcoal-500" data-id="element-37" data-mp="3q9basx4u9ppu">
          Nothing recorded yet.
        </p> : <ul className="mt-6 divide-y divide-navy-100 border-y border-navy-100 bg-white" data-id="element-38" data-mp="1ohopnc7mop1a">
          {rows.map(a => <li key={a.id} className="px-4 py-3" data-id="element-39" data-mp="3ivalziovve8m">
              <p className="font-sans text-[0.875rem] text-ink" data-id="element-40" data-mp="3nnlpeviu1i5x">{a.summary}</p>
              {a.detail ? <p className="mt-0.5 font-sans text-[0.8125rem] text-charcoal-500" data-id="element-41" data-mp="38zh4dkwb4ujz">{a.detail}</p> : null}
              <p className="mt-1 font-sans text-[0.6875rem] uppercase tracking-[0.1em] text-charcoal-300" data-id="element-42" data-mp="3dy24zlfh1g8y">
                {kindLabels[a.kind]} · {formatWhen(a.occurredAt)}
              </p>
            </li>)}
        </ul>}
    </div>;
}